import { pick } from "lodash";
import bowser from "bowser";

export default function getBrowserInfo() {
  const info = {};
  info.browser = JSON.parse(JSON.stringify(bowser));
  Object.assign(info, pick((window && window.navigator) || {}, ["cookieEnabled"]));
  info.localStorage = window && !!window.localStorage;
  info.sessionStorage = window && !!window.sessionStorage;
  return info;
}
